
import { VueSlickPopover, VueSlickPopoverContent } from 'vue-slick-popover'
import 'vue-slick-popover/dist/vue-slick-popover.css'

export default {
  components: {
    VueSlickPopover,
    VueSlickPopoverContent,
  },
  props: {
    blok: {
      type: Object,
      default: () => ({
        img: {},
      }),
    },
    pinSelectedId: {
      type: String,
      default: '',
    },
    index: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      isPopoverVisible: false,
      popoverOptions: {
        animation: 'scale-fade',
        popoverReference: null,
        placement: this.blok.placement || 'bottom',
      },
      top: 0,
      left: 0,
      width: 0,
      height: 0,
    }
  },

  watch: {
    '$store.state.app.breakpoint': {
      handler() {
        // update height width top left on resize
        this.getWidth()
        this.getHeight()
        this.getTopPosition()
        this.getLeftPosition()
      },
    },
    pinSelectedId: {
      handler(val) {
        if (val !== this.blok._uid) {
          this.closePopover()
        }
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.popoverOptions.popoverReference = this.$refs.popoverReference

      this.initScrollTrigger()
      this.getTopPosition()
      this.getLeftPosition()
      this.getWidth()
      this.getHeight()
    })
  },

  methods: {
    getWidth() {
      if (!this.$matchMedia('sm')) {
        this.width = this.blok.mobile_width
          ? this.blok.mobile_width
          : this.blok.width
      } else {
        this.width = this.blok.width
      }
    },
    getHeight() {
      if (!this.$matchMedia('sm')) {
        this.height = this.blok.mobile_height
          ? this.blok.mobile_height
          : this.blok.height
      } else {
        this.height = this.blok.height
      }
    },
    getTopPosition() {
      let top

      if (this.$matchMedia('xs')) top = this.blok.xs_top || this.blok.top
      if (this.$matchMedia('sm')) top = this.blok.sm_top || this.blok.top
      if (this.$matchMedia('md')) top = this.blok.md_top || this.blok.top
      if (this.$matchMedia('lg')) top = this.blok.lg_top || this.blok.top
      if (this.$matchMedia('xl')) top = this.blok.xl_top || this.blok.top

      this.top = top
    },
    getLeftPosition() {
      let left

      if (this.$matchMedia('xs')) left = this.blok.xs_left || this.blok.left
      if (this.$matchMedia('sm')) left = this.blok.sm_left || this.blok.left
      if (this.$matchMedia('md')) left = this.blok.md_left || this.blok.left
      if (this.$matchMedia('lg')) left = this.blok.lg_left || this.blok.left
      if (this.$matchMedia('xl')) left = this.blok.xl_left || this.blok.left

      this.left = left
    },
    initScrollTrigger() {
      // close popover when avatar is out of view
      this.$ScrollTrigger.create({
        start: 0,
        end: 'max',
        onUpdate: () => {
          const isInView = this.$ScrollTrigger.isInViewport(this.$refs.avatar)
          if (!isInView) {
            this.closePopover()
          }
        },
      })
    },
    closePopover() {
      this.$refs.avatar.style.zIndex = 5
      this.isPopoverVisible = false
    },
    openPopover() {
      this.$refs.avatar.style.zIndex = 20
      this.$emit('setId', this.blok._uid)
      this.isPopoverVisible = true
    },
  },
}
